import { CustomerAuthResponse } from './index';

export interface SignInRequest {
  shouldTimeout: boolean;
  userName: string;
  password: string;
  originRoute?: string;
}

export interface SignInResponse extends CustomerAuthResponse {
  jwt: string;
}

// TODO-2gczpn: this seems incorrect -- the actual response payload is much smaller for guest accounts
export interface GetCustomerResponse {
  address: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  country: string;
  state: string;
  city: string;
  zip: string;
  gender: string;
  email: string;
  isGuest: boolean;
  isGuacMode: boolean;
  subscriptions:
    | {
        channel: string;
        context: string;
        created: string;
        status: string;
        statusUpdated: string;
      }[]
    | undefined;
  favoriteRestaurants: FavoriteRestaurant[] | undefined;
  bottomShelfPreference: boolean;
  hasSeenRewardsGenOnboarding: boolean;
  hasSeenRewardsExchOnboarding: boolean;
  numAchievements: number;
  dietaryTags: string[];
}

export enum CustomerSubscriptionStatus {
  Subscribed = 'Subscribed',
  SubscribePending = 'SubscribePending',
  Unsubscribed = 'Unsubscribed',
  UnsubscribePending = 'UnsubscribePending',
}

export interface CustomerSubscription {
  channel: string;
  context: string;
  created: Date;
  status: string;
  statusUpdated: Date;
  subscriptionId?: string;
  subscribedAt?: string;
}

export interface CustomerProfile {
  address?: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  dateOfBirth?: Date;
  isGuest: boolean;
  isGuacMode: boolean;
  country: string;
  state?: string;
  city?: string;
  zip?: string;
  gender?: string;
  email: string;
  subscriptions: CustomerSubscription[];
  bottomShelfPreference: boolean;
  hasSeenRewardsGenOnboarding: boolean;
  hasSeenRewardsExchOnboarding: boolean;
  numAchievements: number;
  dietaryTags?: string[];
  customerIdHash?: string;
}

export interface FavoriteRestaurant {
  name: string;
  restaurantNumber: number;
}

export interface LoyaltyProfile {
  firstName: string;
  lastName: string;
  memberId: string;
  subscribeDate?: string;
}

export interface CustomerAddress {
  locality?: string;
  addressLine1?: string;
  administrativeArea?: string;
  postalCode?: string;
  countryShortName?: string;
  countryCode: string;
}

export interface CustomerDeliveryAddress {
  addressId?: string;
  name?: string;
  customerName?: string;
  companyName?: string;
  phoneNumber?: string;
  selectedDate?: string;
  createdDate?: string;
  streetAddress1?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  notes?: string;
  postalCode?: string;
  province?: string;
  countryCode?: string;
  latitude?: number;
  longitude?: number;
}

export interface DeliveryAddressValidationRequest {
  dropOffAddress: CustomerAddress;
  orderValue: number;
  entreeCount: number;
}

export interface DeliveryAddressValidationResponse {
  data: DeliveryAddressValidationData;
  status: string;
  statusText: string;
}

export interface DeliveryAddressValidationData {
  restaurantId: number;
  minDeliveryTime: number;
  maxDeliveryTime: number;
  pickupTime: string;
  deliveryFee: number;
  meetsMinimumOrderValue: boolean;
  estimateId?: string;
}

export interface CreateUserRequest {
  isAnonymous?: boolean;
  isGuest?: boolean;
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  password?: string;
  phoneNumber?: string;
  country?: string;
  enrollInLoyalty?: boolean;
  enrollInEmailMarketing?: boolean;
  enrollInSmsMarketing?: boolean;
}

export interface CreateUserResponse extends CustomerAuthResponse {
  jwt: string;
}

export interface InitializeVerificationRequest {
  email: string;
  phoneNumber: string;
  password?: string;
}

export interface FinalizeVerificationRequest {
  code: string;
  email: string;
}

export interface FinalizeVerificationResponse extends CustomerAuthResponse {
  jwt: string;
  token: string;
}

export enum CustomerType {
  Guest,
  AutoGenerated,
  Normal,
}

export interface UpgradeGuestUserRequest {
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  password?: string;
  phoneNumber?: string;
  country?: string;
}

export interface ResetPasswordRequest {
  EmailAddress?: string;
  ResetToken?: string;
  NewPassword?: string;
}

export enum MarketingChannel {
  Email = 'email',
  Sms = 'sms',
  EmailAndSms = 'email,sms',
}

export enum MarketingContext {
  Loyalty = 'loyalty',
  Marketing = 'marketing',
  LoyaltyAndMarketing = 'loyalty,marketing',
}
